import PropTypes from 'prop-types';
import React from 'react';
import ConfigConsumer from '@jd/jmtd/es/ConfigConsumer';
import Annotation from '@jd/jmtd/es/Annotation';
import Label from '@jd/jmtd/es/Label';
import { canTouch } from '@jd/jmtd/es/tools/touch';
export default function SummaryCardTitle(_ref) {
  var children = _ref.children,
      info = _ref.info,
      right = _ref.right;
  return /*#__PURE__*/React.createElement(ConfigConsumer, null, function (_ref2) {
    var _ref2$summaryCardTitl = _ref2.summaryCardTitleQuestion,
        summaryCardTitleQuestion = _ref2$summaryCardTitl === void 0 ? 'jmti-question-circle' : _ref2$summaryCardTitl,
        _ref2$summaryCardTitl2 = _ref2.summaryCardTitleTooltipTheme,
        summaryCardTitleTooltipTheme = _ref2$summaryCardTitl2 === void 0 ? 'dark' : _ref2$summaryCardTitl2;
    return /*#__PURE__*/React.createElement("div", {
      className: "jmtp-summary-card-title"
    }, /*#__PURE__*/React.createElement(Label, null, " ", children), info && /*#__PURE__*/React.createElement(Annotation, {
      className: "jmtp-summary-card-title-question",
      icon: summaryCardTitleQuestion,
      theme: summaryCardTitleTooltipTheme,
      placement: "bottom",
      onClick: function onClick(e) {
        if (canTouch) {
          e.preventDefault();
        }
      }
    }, info), /*#__PURE__*/React.createElement("div", {
      className: "jmtp-summary-card-title-right"
    }, right));
  });
}
SummaryCardTitle.propTypes = {
  children: PropTypes.node,
  info: PropTypes.node,
  right: PropTypes.node
};
SummaryCardTitle.defaultProps = {
  children: null,
  info: null,
  right: null
};